import { ServiceList } from "@/components/ServiceList";
import { boardingPdfUrl } from "@/lib/api";
import { Home } from "lucide-react";

export default function Boarding() {
  return (
    <ServiceList
      kind="boarding"
      title="Boarding"
      icon={Home}
      pdfUrlFn={boardingPdfUrl}
      newPath="/boarding/new"
      editPath={(id) => `/boarding/${id}/edit`}
      renderMeta={(r, p) => `${r.boarding_type === "overnight" ? "Overnight" : "Day"} · ${r.branch || ""} · in ${r.check_in ? r.check_in.replace("T", " ") : "—"}`}
    />
  );
}
